module.exports = __webpack_public_path__ + "img/aa-mobile-default.e43f0ba8.png";